import React from "react";
import { LayoutHeader } from "../components";
import { Projects } from "../containers";

const ProjectsPage = () => (
  <LayoutHeader>
    <Projects />
  </LayoutHeader>
);

export default ProjectsPage;
